import { cn } from '@/utils/cn'

interface MetadataFieldProps {
  label: string
  value: string | number | null | undefined
  monospace?: boolean
}

export function MetadataField({ label, value, monospace }: MetadataFieldProps) {
  const display = value == null || value === '' ? '—' : String(value)

  return (
    <div className="flex flex-col gap-1">
      <dt className="text-sm font-medium text-muted-foreground">{label}</dt>
      <dd
        className={cn(
          'text-sm text-foreground',
          monospace && 'font-mono text-xs'
        )}
      >
        {display}
      </dd>
    </div>
  )
}
